import type { AiJumpTarget } from "../atoms/positionAtoms";

/**
 * Plane gate for AI-finding jumps.
 *
 * An AI finding carries only a slice index — no in-slice point. Bounding boxes
 * are deliberately withheld (the 510(k) "clean pixels only" constraint, see
 * `useFindingSlices.ts`), so a cross-plane `jumpToWorld` would have only the
 * target slice's corner ImagePositionPatient to aim at, which snaps
 * coronal/sagittal to a meaningless FOV-edge slice rather than the finding.
 * So an AI-finding jump moves only the finding's OWN series (the plane the AI
 * marked it on); a cross-series viewport — a different plane, or a
 * comparison/prior study sharing the same `aiJumpTargetAtom` — bails.
 * Same-series match is the only ok path. (Tree, 2026-06-02.)
 */
export type AiJumpGateResult =
  | { ok: true }
  | { ok: false; reason: "cross_series_no_inslice_point" };

export function checkAiJumpForGate(ai: AiJumpTarget, seriesId: string): AiJumpGateResult {
  if (ai.seriesId === seriesId) return { ok: true };
  return { ok: false, reason: "cross_series_no_inslice_point" };
}
